import { createSelector } from 'reselect';

export const selectPrintersSlice = state => state.printers;

export const selectPrinters = createSelector(
  selectPrintersSlice,
  slice => slice.printers
);
export const printersLoading = createSelector(
  selectPrintersSlice,
  slice => slice.loading
);
export const printerSettings = createSelector(
  selectPrintersSlice,
  slice => slice.printersDays
);
